import React, { useState } from 'react';
import { Countdown } from './Countdown';
import { Check, Shield, Zap, Lock, CreditCard } from 'lucide-react';
type PlanId = 'primaria' | 'completo' | 'secundaria';
const PLANS: {
  id: PlanId;
  emoji: string;
  title: string;
  desc: string;
  oldPrice: string;
  price: string;
  href: string;
  ctaLabel: string;
}[] = [{
  id: 'primaria',
  emoji: '📘',
  title: 'PRIMARIA',
  desc: '6 tomos + 90 actividades + 6 bonus',
  oldPrice: '$49.990',
  price: '$16.990',
  href: 'https://docentes.profelisto.com.ar/checkouts/cn/hWNDSWNOEV8WRAcUnRNEAOB8/en-ar?_r=AQABFdfs1Tv9BA4Sq6sy0DulG9tm4Z0y6LJ7jGtPhXDTsHo',
  ctaLabel: 'SÍ, QUIERO PACK PRIMARIA →'
}, {
  id: 'completo',
  emoji: '🏆',
  title: 'PACK COMPLETO',
  desc: '12 tomos + 180 actividades + 6 bonus + 2 EBOOKS ÉLITE',
  oldPrice: '$99.980',
  price: '$27.990',
  href: 'https://docentes.profelisto.com.ar/checkouts/cn/hWNDSWNlLOEm27vBqTOYSsi2/en-ar?_r=AQABgnugzR036UpT87u-CFYVkofIU7kMtV2hWKmUqiOmBCc',
  ctaLabel: 'SÍ, QUIERO PACK COMPLETO →'
}, {
  id: 'secundaria',
  emoji: '📗',
  title: 'SECUNDARIA',
  desc: '6 tomos + 90 actividades + 6 bonus',
  oldPrice: '$49.990',
  price: '$18.990',
  href: 'https://docentes.profelisto.com.ar/checkouts/cn/hWNDSWNYUSrBWKu1SDr9bfgg/en-ar?_r=AQAB_kPVjNNGM93oBh3oGzW1YAKrNGpcNLka_TMrtKbcufY',
  ctaLabel: 'SÍ, QUIERO PACK SECUNDARIA →'
}];
export function Pricing() {
  const [selected, setSelected] = useState<PlanId>('completo');
  const selectedPlan = PLANS.find(p => p.id === selected)!;
  return <section className="py-10 md:py-16 bg-[#FBF6EC]" data-id="element-137">
      <div className="max-w-6xl mx-auto px-4" data-id="element-138">
        {/* URGENCY & COUNTDOWN */}
        <div className="text-center mb-10 md:mb-16 bg-amber-50 p-6 md:p-8 rounded-3xl border-2 border-amber-200 max-w-3xl mx-auto" data-id="element-139">
          <h2 className="text-xl md:text-2xl font-bold text-rose-900 mb-6 uppercase tracking-wide" data-id="element-140">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>
          <Countdown className="mb-6" data-id="element-141" />
          <p className="text-lg text-stone-700 font-medium mb-4" data-id="element-142">
            Después sube $10.000 ARS y no vuelve a bajar.
          </p>
          <div className="max-w-md mx-auto" data-id="element-143">
            <div className="flex justify-between text-sm font-bold text-stone-600 mb-2" data-id="element-144">
              <span data-id="element-145">Cupos al precio de lanzamiento:</span>
              <span data-id="element-146">68% tomados</span>
            </div>
            <div className="w-full bg-stone-200 rounded-full h-4 mb-4 overflow-hidden" data-id="element-147">
              <div className="bg-amber-600 h-4 rounded-full" style={{
              width: '68%'
            }} data-id="element-148"></div>
            </div>
            <a href="#comprar" className="text-amber-700 font-bold hover:underline" data-id="element-149">
              → ASEGURAR MI PRECIO AHORA
            </a>
          </div>
        </div>

        {/* PRICING TABLE HEADER */}
        <div id="comprar" className="scroll-mt-4 text-center mb-6 md:mb-10" data-id="element-150">
          <h2 className="text-2xl md:text-4xl font-black text-stone-900 mb-1 md:mb-4" data-id="element-151">
            Elegí tu Lengua Pack:
          </h2>
          <p className="text-sm md:text-xl text-stone-600 font-medium" data-id="element-152">
            Todas las opciones incluyen los 6 bonus estratégicos
          </p>
        </div>

        {/* STACKED ROW SELECTOR */}
        <div className="max-w-2xl mx-auto space-y-3 md:space-y-4 mb-6" data-id="element-153">
          {PLANS.map(plan => {
          const isSelected = selected === plan.id;
          return <button key={plan.id} type="button" onClick={() => setSelected(plan.id)} className={`w-full text-left rounded-2xl p-4 md:p-5 flex items-center gap-3 md:gap-4 transition-all border-2 ${isSelected ? 'border-amber-500 bg-amber-50 shadow-lg ring-2 ring-amber-200' : 'border-stone-200 bg-white hover:border-stone-300'}`} data-id="element-154">
                {/* Radio */}
                <span className={`flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-amber-500' : 'border-stone-300'}`} data-id="element-155">
                  {isSelected && <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-amber-500" data-id="element-156" />}
                </span>

                {/* Title + desc */}
                <div className="flex-grow min-w-0" data-id="element-157">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-158">
                    <span className="font-black text-stone-900 text-base md:text-lg" data-id="element-159">
                      {plan.emoji} {plan.title}
                    </span>
                    {plan.id === 'completo' && <>
                        <span className="bg-amber-500 text-white font-black text-[10px] md:text-xs px-2 py-0.5 rounded-full uppercase tracking-wide whitespace-nowrap" data-id="element-160">
                          ⭐ MÁS ELEGIDO
                        </span>
                        <span className="bg-amber-100 text-amber-700 font-black text-[10px] md:text-xs px-2 py-0.5 rounded-full uppercase tracking-wide whitespace-nowrap" data-id="element-161">
                          AHORRÁS $7.990
                        </span>
                      </>}
                  </div>
                  <p className="text-xs md:text-sm text-stone-600 font-medium mt-0.5" data-id="element-162">
                    {plan.desc}
                  </p>
                </div>

                {/* Prices */}
                <div className="flex-shrink-0 text-right" data-id="element-163">
                  <div className="text-xs md:text-sm text-stone-400 line-through font-bold" data-id="element-164">
                    {plan.oldPrice}
                  </div>
                  <div className={`font-black text-xl md:text-2xl ${isSelected ? 'text-amber-600' : 'text-stone-900'}`} data-id="element-165">
                    {plan.price}
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* DYNAMIC CTA */}
        <div className="max-w-2xl mx-auto mb-3" data-id="element-166">
          <a href={selectedPlan.href} className="block w-full bg-amber-500 hover:bg-amber-600 text-white text-center font-black py-4 md:py-5 text-base md:text-lg rounded-xl shadow-lg hover:shadow-xl transition-all" data-id="element-167">
            {selectedPlan.ctaLabel}
          </a>
        </div>

        <p className="text-center italic text-sm md:text-base text-stone-500 mb-10 md:mb-16" data-id="element-168">
          La opción más elegida por docentes que enseñan en los dos niveles
        </p>

        {/* TRUST BADGES */}
        <div className="flex flex-wrap justify-center gap-6 text-sm font-bold text-stone-600 mb-16" data-id="element-169">
          <div className="flex items-center gap-2" data-id="element-170">
            <Lock className="w-5 h-5 text-stone-400" data-id="element-171" /> 🔒 Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-172">
            <Zap className="w-5 h-5 text-amber-500" data-id="element-173" /> ⚡ Acceso en 5 min
          </div>
          <div className="flex items-center gap-2" data-id="element-174">
            <Shield className="w-5 h-5 text-emerald-600" data-id="element-175" /> 🛡️ Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-176">
            <CreditCard className="w-5 h-5 text-rose-800" data-id="element-177" /> 💳 Mercado Pago
          </div>
        </div>

        {/* DETALLE PACK COMPLETO */}
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 border border-stone-200" data-id="element-178">
          <div className="text-center mb-8" data-id="element-179">
            <p className="text-amber-600 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-180">
              La opción más elegida por docentes que enseñan en los dos niveles
            </p>
            <h3 className="text-3xl font-black text-stone-900" data-id="element-181">
              PACK COMPLETO INCLUYE:
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-182">
            {['12 tomos completos', '180 actividades con secuencia', 'Primaria + Secundaria', 'Solucionarios incluidos', '6 Bonus estratégicos', 'Planificación Anual lista (Ebook Élite 1)', '3 Proyectos Institucionales listos para firmar (Ebook Élite 2)', 'Acceso inmediato PDF'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-183">
                <Check className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-184" />
                <span className="text-stone-800 font-medium" data-id="element-185">{item}</span>
              </div>)}
          </div>

          <div className="text-center border-t border-stone-200 pt-8" data-id="element-186">
            <p className="text-2xl font-black text-stone-900" data-id="element-187">
              Solo por $27.990 ARS
            </p>
          </div>
        </div>
      </div>
    </section>;
}